<template>

    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark color="primary" style="position: sticky; top: 0; z-index: 1">
                <v-btn icon dark @click="close"><v-icon>mdi-close</v-icon></v-btn>
                <v-toolbar-title>Nova Região</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark text @click="save" :disabled="!valid">Salvar</v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card-text class="mt-5">
                <v-form id="formCadastroRegiao" ref="formCadastroRegiao" v-model="valid" lazy-validation >
                    <v-row>
                        <v-col cols="12" md="2">
                            <v-text-field v-model="item.id" label="Código" readonly dense outlined/>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field v-model="item.nome" label="Nome" :rules="fieldRules" :counter="45" maxlength="45" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="item.composicao" label="Composição" :counter="150" maxlength="150" dense outlined/>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>

        <v-overlay :value="salvando">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </v-dialog>

</template>
<script>
import RegiaoService from '@/core/services/doacao/RegiaoService';
import Regiao from '@/core/domain/doacao/Regiao';

export default {
    props:{
        item: {
            required: true
        },
        value: {}
    },
    watch: { 
        item: function() { 
            if ('formCadastroRegiao' in this.$refs)
                this.$refs.formCadastroRegiao.resetValidation();
        },
        value: function() {
            this.dialog = this.value;
        },
        dialog: function() {
            if (!this.dialog) {
                this.$emit('fechou');
            }
        }
    },
    data: () => ({
        service: new RegiaoService(),
        valid: true,
        dialog: false,
        isLoading: false,
        fieldRules: [
            v => !!v || 'Campo obrigatório'
        ],
        sessionApp: {},
        salvando: false
    }),
    methods: {
        save() {

            if (this.$refs.formCadastroRegiao.validate()) {

                let modelo = new Regiao(this.item);

                this.salvando = true;

                this.service.Salvar(modelo).then(
                    res => {
                        this.$swal('Aviso', 'Operação realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
                        this.$emit('salvou');
                        this.close();
                    }, 
                    err =>  {
                        if (err.response.status == 400) {
                            this.$swal('Aviso', err.response.data.title, 'warning')    
                        }
                        else {
                            this.$swal('Aviso', err.response.data, 'error')
                        }
                    }
                ).finnaly(() => {
                    this.salvando = false;
                })
            }
        },
        close() {
            this.dialog = false;
        }
    },
    beforeUpdate(){
        if (!this.dialog){
            this.$emit('fechou');
        }
    },
    mounted() {

    }
}
</script>